<template>
  <v-dialog max-width="500px" persistent v-model="dialog" scrollable>
    <v-card>
      <v-toolbar dark dense>
        <v-toolbar-title class="headline">{{formTitle}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-icon @click="$emit('setDialog', false) && $emit('setEditIndex',-1)">close</v-icon>
      </v-toolbar>

      <v-card-text style="height: auto;">
        <v-form ref="form" v-model="valid" lazy-validation>
          <!-- <v-layout row wrap>
          <v-flex xs12 md6>-->
          <v-text-field
            v-model="form.vehicle_title_th"
            :loading="fetching_loading == true ? 'black' : false"
            label="Vehicle TH"
            :rules="[v => !!v || 'Required']"
          ></v-text-field>
          <v-text-field
            v-model="form.vehicle_title_en"
            :loading="fetching_loading == true ? 'black' : false"
            label="Vehicle EN"
            :rules="[v => !!v || 'Required']"
          ></v-text-field>
          <v-text-field
            v-model="form.vehicle_title_cn"
            :loading="fetching_loading == true ? 'black' : false"
            label="Vehicle CN"
          ></v-text-field>
          <v-text-field
            v-model="form.vehicle_weight_carry"
            :loading="fetching_loading == true ? 'black' : false"
            label="Weight carry (Kg.)"
            type="number"
            :rules="[v => !!v || 'Required']"
          ></v-text-field>
          <v-layout row justify-center>
            <v-flex>
              <v-text-field
                v-model="form.vehicle_size_width"
                :loading="fetching_loading == true ? 'black' : false"
                label="Width"
                type="Number"
                :rules="[v => !!v || 'Required']"
              ></v-text-field>
            </v-flex>
            <v-flex class="ml-3 mr-3" style="align-self: center;">X</v-flex>
            <v-flex>
              <v-text-field
                v-model="form.vehicle_size_length"
                :loading="fetching_loading == true ? 'black' : false"
                label="Length"
                type="Number"
                :rules="[v => !!v || 'Required']"
              ></v-text-field>
            </v-flex>
            <v-flex class="ml-3 mr-3" style="align-self: center;">X</v-flex>
            <v-flex>
              <v-text-field
                v-model="form.vehicle_size_height"
                :loading="fetching_loading == true ? 'black' : false"
                label="Height"
                type="Number"
                :rules="[v => !!v || 'Required']"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex class="mr-1">
              <v-text-field
                :loading="fetching_loading == true ? 'black' : false"
                v-model="form.vehicle_price"
                type="number"
                label="Start price"
                :rules="[v => !!v || 'Required']"
              ></v-text-field>
            </v-flex>
            <v-flex class="mx-1">
              <v-text-field
                :loading="fetching_loading == true ? 'black' : false"
                v-model="form.vehicle_std_price"
                type="number"
                label="Min price"
                :rules="[v => !!v || 'Required']"
              ></v-text-field>
            </v-flex>
            <v-flex class="ml-1">
              <v-text-field
                :loading="fetching_loading == true ? 'black' : false"
                v-model="form.vehicle_price_per_point"
                type="number"
                label="Price per point"
                :rules="[v => !!v || 'Required']"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <!-- <v-layout row wrap class="mt-2">
                        <v-flex xs6 style="position:relative;">
                        <label
                            style="font-size:17px;position:absolute;top:15px;color:#616A6B;"
                        >Upload Add-on Image :</label>
                        </v-flex>
                        <v-flex class="ml-2">
                        <v-btn @click="$refs.LogoInput.click()">Choose Files</v-btn>
                        <input
                            style="display:none;"
                            type="file"
                            ref="LogoInput"
                            accept="image/*"
                        >
                        </v-flex>
                    </v-layout>
          <span>img123.jpg</span>-->
          <!-- </v-flex>
          <v-flex xs12 md6>-->
          <v-layout row wrap class="mt-2">
            <v-flex xs6 style="position:relative;">
              <v-layout row>
                <label class="text-icon">Icon :</label>
                <img
                  height="40px"
                  width="40px"
                  :src="form.vehicle_image"
                  alt
                  v-if="form.vehicle_image != null"
                  class="ml-3 mt-1"
                />
                <v-card
                  v-if="form.vehicle_image == null"
                  height="40px"
                  width="40px"
                  color="grey"
                  class="ml-3 mt-1 text-xs-center pt-2"
                >
                  <v-icon color="white">photo</v-icon>
                </v-card>
                <!-- <img height="40px" width="40px" :src="form.vehicle_image" alt="" v-if="form.vehicle_image != null"> -->
                <!-- <v-card height="40px" width="40px" color="grey" class="ml-3 mt-2">img</v-card> -->
                <v-btn
                  class="black--text ml-3"
                  @click="$refs.LogoInput.click()"
                >{{form.vehicle_image == null ? 'add icon' : 'edit icon'}}</v-btn>
              </v-layout>
            </v-flex>
            <v-flex>
              <input
                style="display:none;"
                @change="onLogoSelected"
                type="file"
                ref="LogoInput"
                accept="image/*"
              />
            </v-flex>
          </v-layout>
          <v-divider class="mt-4" />

          <v-layout row style="position:relative;">
            <v-flex style="font-size:16px;position:absolute;bottom:10px;">
              <strong>Set distance</strong>
            </v-flex>
            <v-flex class="text-xs-right">
              <v-btn
                round
                small
                color="primary"
                @click="adddistance=!adddistance"
                class="black--text mt-3"
                v-if="!isEditVehicle"
              >
                <v-icon>add</v-icon>add distance
              </v-btn>
            </v-flex>
          </v-layout>
          <v-card class="my-2" v-if="adddistance">
            <v-card-text class="pt-1">
              <v-form ref="form_distance" v-model="valid" lazy-validation>
                <v-layout>
                  <v-flex class="mr-1">
                    <v-text-field
                      v-model="form_distance.vsc_start"
                      type="number"
                      label="Start distance"
                      :rules="[v => !!v || 'Required']"
                    ></v-text-field>
                  </v-flex>
                  <v-flex class="mx-1">
                    <v-text-field
                      v-model="form_distance.vsc_end"
                      type="number"
                      label="End distance"
                      :rules="[v => !!v || 'Required']"
                    ></v-text-field>
                  </v-flex>
                  <v-flex class="mx-1">
                    <v-text-field
                      v-model="form_distance.vsc_charge"
                      type="number"
                      label="Price"
                      :rules="[v => !!v || 'Required']"
                    ></v-text-field>
                  </v-flex>
                  <v-flex class="ml-1 pt-2">
                    <v-btn
                      small
                      color="green"
                      :disabled="isEditVehicle"
                      @click="saveDistance()"
                    >submit</v-btn>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-card-text>
          </v-card>
          <v-data-table
            :loading="fetching_loading == true ? 'black' : false"
            :headers="headers"
            :items="form.vehicle_set_distance"
            :pagination.sync="pagination"
            class="elevation-1"
            hide-actions
          >
            <template slot="items" slot-scope="props">
              <td class="text-xs-left">{{ props.item.vsc_start }} - {{ props.item.vsc_end }}</td>
              <td class="text-xs-center">
                {{ props.item.vsc_charge }}
                <!-- <v-text-field label="Price" style="padding-bottom:10px;"></v-text-field> -->
              </td>
              <td class="justify-center layout px-0">
                <v-tooltip top>
                  <v-btn
                    icon
                    slot="activator"
                    @click="form.vehicle_set_distance.splice(props.index,1)"
                  >
                    <v-icon small>delete</v-icon>
                  </v-btn>
                  <span>Delete</span>
                </v-tooltip>
                <v-switch
                  v-model="props.item.vsc_active"
                  color="primary"
                  style="max-width:50px;margin-top:11px;"
                ></v-switch>
              </td>
            </template>
          </v-data-table>
          <!-- </v-flex>
          </v-layout>-->
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <span transition="fade">
          <v-icon color="green" v-if="update_loading == 2">check</v-icon>
          <v-icon color="red" v-if="update_loading == 3">close</v-icon>
          <v-progress-circular
            :width="3"
            :size="15"
            indeterminate
            color="grey"
            v-if="update_loading == 1"
          ></v-progress-circular>
          {{ update_loading == 1 ? 'Updating' : update_loading == 2 ? 'Update successfully' : update_loading == 3 ? 'Cant update' : null}}
        </span>
        <v-btn
          color="red"
          flat
          @click="$emit('setDialog', false) && $emit('setEditIndex',-1)"
        >Cancel</v-btn>
        <v-btn :disabled="isEditVehicle" color="green" flat @click="save()">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: ["dialog", "editedIndex", "form", "fetching_loading"],
  data() {
    return {
      update_loading: 0,
      change_image: 0,
      form_distance: {},
      valid: true,
      adddistance: false,
      pagination: {
        rowsPerPage: 10
      },
      headers: [
        {
          text: "Distance (Km)",
          value: "start",
          align: "center",
          sortable: false
        },
        { text: "Price", value: "price", align: "center", sortable: false },
        { text: "Action", value: "action", align: "center", sortable: false }
      ],
      addons: [
        {
          start: "0",
          end: "30",
          price: "10",
          action: ""
        },
        {
          start: "31",
          end: "60",
          price: "15",
          action: ""
        }
      ]
    };
  },
  watch: {
    dialog() {
      if (this.dialog == false) {
        this.change_image = 0;
        this.update_loading = 0;
      } else {
        this.$refs.form.reset();
      }
    }
  },
  computed: {
    ...mapGetters(["isEditVehicle"]),
    formTitle() {
      return this.editedIndex === -1 ? "New vehicle type" : "Edit vehicle type";
    }
  },
  methods: {
    onLogoSelected(event) {
      this.form.vehicle_image = "";
      let file = event.target.files[0];
      let reader = new FileReader();
      reader.addEventListener("load", () => {
        this.form.vehicle_image = reader.result;
      });
      this.change_image = 1;
      reader.readAsDataURL(file);
    },
    saveDistance() {
      if (this.$refs.form_distance.validate()) {
        this.form.vehicle_set_distance.push(this.form_distance);
        this.form_distance = {};
        this.adddistance = false;
      }
    },
    toAddDistance() {
      this.form_distance = {
        vsc_active: false
      };
    },
    validationDistance() {
      let check = true;
      for (let key in this.form.vehicle_set_distance) {
        if (key != 0) {
          if (
            this.form.vehicle_set_distance[key].vsc_start !=
            this.form.vehicle_set_distance[key - 1].vsc_end
          ) {
            check = false;
          }
        }
      }
      return check;
    },
    async save() {
      if (
        this.form.vehicle_set_distance.length != 0 &&
        this.$refs.form.validate()
      ) {
        if (this.validationDistance()) {
          let obj1 = JSON.parse(JSON.stringify(this.form));
          if (this.change_image == 0) {
            delete obj1.vehicle_image;
          }
          if (obj1.vehicle_size_width) {
            obj1.vehicle_size_carry = obj1.vehicle_size_width + " x ";
          }
          if (obj1.vehicle_size_length) {
            obj1.vehicle_size_carry += obj1.vehicle_size_length + " x ";
          }
          if (obj1.vehicle_size_height) {
            obj1.vehicle_size_carry += obj1.vehicle_size_height;
          }
          delete obj1.vehicle_size_width;
          delete obj1.vehicle_size_length;
          delete obj1.vehicle_size_height;
          if (this.editedIndex == -1) {
            this.$store.dispatch("fetchMessVehicleBack/addVehicle", obj1);
            this.$emit("setDialog", false);
            this.$emit("setEditIndex", -1);
          } else {
            this.update_loading = 1;
            this.update_loading = await this.$store.dispatch(
              "fetchMessVehicleBack/editVehicle",
              obj1
            );
          }
        } else {
          alert("กรอกข้อมูลเส้นทางไม่ถูกต้อง");
        }
      } else {
        alert("กรอกข้อมูลให้ครบถ้วน");
      }
    }
  }
};
</script>
<style scoped>
.text-icon {
  font-size: 17px;
  margin-top: 10px;
  color: #616a6b;
}
</style>




